import { Events } from '|>/shared/events'
import { span } from '|>/shared/h'
import { Intent } from '|>/shared/types/intent'
import { on, register } from '|>/shared/vjs'
import { BaseButton, BaseSeekToLive } from '../base'

import './seek-to-live.css'

@register
export class SeekToLive extends BaseSeekToLive {
  declare textEl_: HTMLSpanElement

  @on(Events.Media.IsRewound)
  private isRewound: Events.Media.IsRewound = false

  @on(Events.Media.IsAutoLiveTracker)
  private isAutoLiveTracker: Events.Media.IsAutoLiveTracker = false

  override createEl() {
    const el = BaseButton.prototype.createEl.call(this, 'button', {
      className: 'vjs-seek-to-live-control vjs-control',
    })

    el.querySelector('.vjs-icon-placeholder')?.remove()

    this.textEl_ = span('.vjs-seek-to-live-text', {
      ariaHidden: 'true',
    })
    this.textEl_.textContent = this.localize('LIVE')
    el.appendChild(this.textEl_)

    return el
  }

  @on(Events.Media.IsRewound)
  override updateLiveEdgeStatus() {
    if (this.isAutoLiveTracker) return super.updateLiveEdgeStatus()

    if (this.isRewound) {
      this.setAttribute('aria-disabled', 'false')
      this.removeClass('vjs-at-live-edge')
    } else {
      this.setAttribute('aria-disabled', 'true')
      this.addClass('vjs-at-live-edge')
    }
  }

  override handleClick() {
    // TODO debounce
    if (this.isAutoLiveTracker) return super.updateLiveEdgeStatus()

    this.player_.trigger(Events.User.Intent, Intent.GoLive)
    this.player_.trigger(Events.Player.GoLive)
  }
}

SeekToLive.options = {
  className: 'vjs-x-seek-to-live-control',
}
